import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { HeaderCell, HeightCell } from './height-cells';

export const createHeightColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'height',
  Header: HeaderCell,
  Cell: HeightCell,
  width: 1,
  minWidth: 100,
});
